import CardStepItem from './CardStepItem';
import FormFieldLayout from '../../../../components/shared/formFieldRelated/FormFieldLayout';
import { BookRideFieldNames } from '../../types';
import RHFTextField from '../../../../components/shared/formFieldRelated/RHFTextField';
import React, { FC, ReactElement } from 'react';
import { Typography, MenuItem } from '@mui/material';
import { TYPOGRAPHY } from '../../../../theme/typography';
import { useFormContext } from 'react-hook-form';
import { RHFSelect } from '../../../../components/shared/formFieldRelated/RHFSelect';

interface Props
{
  onContinue: () => void;
  onEdit: () => void;
  isEditing: boolean;
  displayEditButton: boolean;
}

const SpecialRequests: FC<Props> = ({
  onContinue,
  onEdit,
  isEditing,
  displayEditButton,
}): ReactElement =>
{
  const { watch, setValue } = useFormContext();
  const [specialRequest, convoPref] = watch([BookRideFieldNames.SPECIAL_REQUESTS, BookRideFieldNames.CONVO_PREF]);

  return (
    <CardStepItem
      title={`Special requests`}
      onContinue={onContinue}
      onEdit={onEdit}
      isEditing={isEditing}
      displayEditButton={displayEditButton}
      containerDataCy="addons-card"
      buttonDataCy="addons-continue-btn"
      editButtonDataCy="addons-edit-btn"
    >
      {!isEditing && (
        <>
          {specialRequest && (
            <>
              <Typography
                sx={{
                  ...TYPOGRAPHY.paragraph,
                  mt: '5px!important',
                }}
              >
                {specialRequest}
              </Typography>
            </>
          )}

          {convoPref && (
            <Typography
              sx={{
                ...TYPOGRAPHY.paragraph,
                mt: '5px!important',
              }}
            >
              Conversation: {convoPref}
            </Typography>
          )}
        </>
      )}
      {isEditing && (
        <FormFieldLayout
          name={BookRideFieldNames.SPECIAL_REQUESTS}
          label=""
          dataCy="special-requests-textfield"
        >
          <RHFTextField
            name={BookRideFieldNames.SPECIAL_REQUESTS}
            placeholder="Any special requests or needs?"
            type="textarea"
            inputProps={{
              maxLength: 500,
            }}
          />
          <Typography
            sx={{
              ...TYPOGRAPHY.paragraph,
              mt: '7px',
            }}
            data-cy="charsLeft"
          >
            {(specialRequest && specialRequest.length) || 0}/500 characters
            including space
          </Typography>

          <Typography
            align='left'
            sx={{
              ...TYPOGRAPHY.paragraph,
              mt: '20px',
            }}
          >
            Conversation preference
          </Typography>
          <RHFSelect
            name={BookRideFieldNames.CONVO_PREF}
            rendervalue={(obj: unknown): string =>
            {
              return (obj as string === '' ? 'No preference' : obj as string)
            }}
            onChange={(e): void =>
            {
              setValue(BookRideFieldNames.CONVO_PREF, e.target.value);
            }}
          >
            <MenuItem value="">No preference</MenuItem>
            <MenuItem value="Prefer to focus">Prefer to focus</MenuItem>
            <MenuItem value="Up for chatting">Up for chatting</MenuItem>
          </RHFSelect>
        </FormFieldLayout>
      )}
    </CardStepItem>
  );
};

export default SpecialRequests;
